import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/sv';
import 'moment/locale/da';
import 'moment/locale/nb';

export const setMomentLocale = (locale: string) => {
  if (locale === 'nb') {
    locale = 'no';
  }
  moment.locale(locale);
};
